// src/views/Components/Chat/ChatWindow.js

import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Box,
  Typography,
  Avatar,
  IconButton,
  TextField,
  Button,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { contacts } from "./mockData";

function ChatWindow() {
  const { id } = useParams();
  const history = useHistory();
  const contact = contacts.find((c) => c.id === parseInt(id));

  const [input, setInput] = useState("");

  const handleSend = () => {
    if (input.trim() === "") return;
    // In real app: send to server
    alert(`Sending message: ${input}`);
    setInput("");
  };

  if (!contact) {
    return <Box p={2}>Contact not found.</Box>;
  }

  return (
    <Box display="flex" flexDirection="column" height="100vh">
      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        p={2}
        borderBottom="1px solid #ddd"
      >
        <IconButton onClick={() => history.push("/chats")}>
          <ArrowBackIcon />
        </IconButton>
        <Avatar src={contact.avatar} />
        <Typography variant="h6" style={{ marginLeft: 8 }}>
          {contact.name}
        </Typography>
      </Box>

      {/* Messages */}
      <Box flex={1} p={2} overflow="auto">
        {contact.messages.map((msg) => (
          <Box
            key={msg.id}
            display="flex"
            justifyContent={msg.fromMe ? "flex-end" : "flex-start"}
            mb={1}
          >
            <Box
              bgcolor={msg.fromMe ? "#DCF8C6" : "#FFF"}
              px={2}
              py={1}
              borderRadius={8}
              maxWidth="70%"
              boxShadow={1}
            >
              <Typography variant="body1">{msg.text}</Typography>
            </Box>
          </Box>
        ))}
      </Box>

      {/* Input */}
      <Box display="flex" alignItems="center" p={2} borderTop="1px solid #ddd">
        <TextField
          fullWidth
          placeholder="Type a message"
          variant="outlined"
          size="small"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <Button
          onClick={handleSend}
          variant="contained"
          color="primary"
          style={{ marginLeft: 8 }}
        >
          Send
        </Button>
      </Box>
    </Box>
  );
}

export default ChatWindow;
